import { useQuery } from '@apollo/client'
import { GetBrandReviewSummaryQuery, GetBrandReviewSummaryQueryVariables } from 'types/graphql'
import { getBrandReviewSummary } from 'modules/brands/queries/brandReviewSummary.graphql'

export const useBrandReviewSummary = (variables: GetBrandReviewSummaryQueryVariables) =>
  useQuery<GetBrandReviewSummaryQuery, GetBrandReviewSummaryQueryVariables>(getBrandReviewSummary, { variables })
